import { defineStore } from 'pinia';

export const useContextStore = defineStore('context', {
  state: () => ({
    lang: 'pt',
    dark_mode: false,
    loading_application: true
  }),
  actions: {
    setLang(chosenLang = 'pt') {
      this.lang = chosenLang;
    },
    setDarkMode(value = true) {
      this.dark_mode = value;
    },
    setLoadingApplication(value = true) {
      this.loading_application = value;
    }
  },
  getters: {
    getLang: (state) => state.lang,
    getAvaliableLangs: () => ['en','pt','es'],
    isDarkMode: (state) => state.dark_mode,
    getColorMode: (state) => state.dark_mode ? 'dark' : 'light',
    isLoadingApplication: (state) => state.loading_application
  }
})
